// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1vqgg17y .mvng-hide-controls{transition:opacity .3s}._16jlkb7n{flex-grow:1}\n._18m9ewfl{overflow-y:visible}\n._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1o9zkb7n{flex-shrink:1}\n._1reoewfl{overflow-x:visible}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}\n._bq91idpf .mvng-hide-controls{opacity:0}\n._bq91kb7n .mvng-hide-controls{opacity:1}\n._i0dlf1ug{flex-basis:0%}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
